var app = angular.module('app');
app.controller('appCtrl', [
    "$scope",
    "$firebaseAuth",
    "$firebaseArray",
    "$q",
    function($scope, $firebaseAuth, $firebaseArray, $q) {
        $scope.title = 'Submissions';
        $scope.authObj = $firebaseAuth();
        $scope.authObj.$onAuthStateChanged(function(firebaseUser) {
            if (firebaseUser) firebaseUser.getIdTokenResult().then(function(idTokenResult) {
                $scope.$apply(function() {
                    $scope.isAuthenticated = true;
                    $scope.isAdmin = !!idTokenResult.claims.admin;
                });
            });
            else window.location.href = '/login/login';
        }, function(error) {
            console.error("Authentication state error:", error);
        });
        var ref = firebase.database().ref();
        $scope.remoteItems = $firebaseArray(ref.child("submission"));
        $scope.guilds = $firebaseArray(ref.child("guild"));
        $scope.expansions = $firebaseArray(ref.child("expansion"));
        $scope.zones = $firebaseArray(ref.child("zone"));
        $scope.bosses = $firebaseArray(ref.child("boss"));
        $scope.DB = [];
        $scope.remoteItems.$loaded().then(function() {
            angular.forEach($scope.remoteItems, function(item) {
                var newItem = new Object();
                newItem.$id = item.$id;
                newItem.guild = item.guild;
                newItem.expansion = item.expansion;
                newItem.zone = item.zone;
                newItem.boss = item.boss;
                newItem.timestamp = item.timestamp;
                newItem.imageUrl = item.imageUrl;
                $scope.DB.push(newItem);
            });
        });
        $scope.getGuildName = function(guildId) {
            if (!guildId) return '';
            var record = $scope.guilds.$getRecord(guildId);
            return record ? record.name : 'Loading...';
        };
        $scope.getExpansionName = function(expansionId) {
            if (!expansionId) return '';
            var record = $scope.expansions.$getRecord(expansionId);
            return record ? record.name : 'Loading...';
        };
        $scope.getZoneName = function(zoneId) {
            if (!zoneId) return '';
            var record = $scope.zones.$getRecord(zoneId);
            return record ? record.name : 'Loading...';
        };
        $scope.getBossName = function(bossId) {
            if (!bossId) return '';
            var record = $scope.bosses.$getRecord(bossId);
            return record ? record.name : 'Loading...';
        };
        $scope.add = function() {
            window.location.href = '/submission/add';
        };
        $scope.cleanupSubmission = function(item) {
            var record = $scope.remoteItems.$getRecord(item.$id);
            $scope.remoteItems.$remove(record).then(function() {
                var index = $scope.DB.indexOf(item);
                if (index > -1) $scope.DB.splice(index, 1);
                if (item.imageUrl) {
                    var storageRef = firebase.storage().refFromURL(item.imageUrl);
                    storageRef.delete().catch(function(error) {
                        console.error("Error deleting image:", error);
                    });
                }
            });
        };
        $scope.delete = function(item) {
            if (!$scope.isAdmin) {
                alert('Only administrators can deny submissions.');
                return;
            }
            if (confirm('Would you like to deny this submission?')) $scope.cleanupSubmission(item);
        };
        function recalculateZoneMedals(zoneId, currentGuildId, currentTimestamp) {
            var clearRecords = [];
            angular.forEach($scope.guilds, function(g) {
                if (!g.zoneMedals || !g.zoneMedals[zoneId] || !g.zoneMedals[zoneId].timestamp) return;
                var zoneMedals = g.zoneMedals[zoneId];
                clearRecords.push({
                    guild: g,
                    timestamp: new Date(zoneMedals.timestamp).getTime(),
                    zoneMedals: zoneMedals
                });
            });
            if (currentGuildId && currentTimestamp) {
                var currentGuild = $scope.guilds.$getRecord(currentGuildId);
                if (currentGuild) {
                    var hasExistingRecord = false;
                    angular.forEach(clearRecords, function(record) {
                        if (record.guild && record.guild.$id === currentGuildId) {
                            hasExistingRecord = true;
                            record.timestamp = new Date(currentTimestamp).getTime();
                            record.zoneMedals = currentGuild.zoneMedals && currentGuild.zoneMedals[zoneId] ? currentGuild.zoneMedals[zoneId] : {};
                        }
                    });
                    if (!hasExistingRecord) clearRecords.push({
                        guild: currentGuild,
                        timestamp: new Date(currentTimestamp).getTime(),
                        zoneMedals: currentGuild.zoneMedals && currentGuild.zoneMedals[zoneId] ? currentGuild.zoneMedals[zoneId] : {}
                    });
                }
            }
            clearRecords.sort(function(a, b) {
                return a.timestamp - b.timestamp;
            });
            angular.forEach($scope.guilds, function(g) {
                if (!g.zoneMedals) g.zoneMedals = {};
                if (!g.zoneMedals[zoneId]) g.zoneMedals[zoneId] = {};
                delete g.zoneMedals[zoneId].gold;
                delete g.zoneMedals[zoneId].silver;
                delete g.zoneMedals[zoneId].bronze;
                delete g.zoneMedals[zoneId].cleared;
            });
            angular.forEach(clearRecords, function(record, index) {
                var guild = record.guild;
                if (!guild.zoneMedals) guild.zoneMedals = {};
                if (!guild.zoneMedals[zoneId]) guild.zoneMedals[zoneId] = {};
                guild.zoneMedals[zoneId].timestamp = new Date(record.timestamp).toISOString();
                if (index === 0) guild.zoneMedals[zoneId].gold = true;
                else if (index === 1) guild.zoneMedals[zoneId].silver = true;
                else if (index === 2) guild.zoneMedals[zoneId].bronze = true;
                else guild.zoneMedals[zoneId].cleared = true;
            });
            angular.forEach($scope.guilds, function(g) {
                if (!g.expansionMedalPoints) g.expansionMedalPoints = {};
                angular.forEach($scope.expansions, function(expansion) {
                    var medalPoints = 0;
                    angular.forEach(g.zoneMedals || {}, function(zoneMedals, zoneKey) {
                        var zoneRecord = $scope.zones.$getRecord(zoneKey);
                        if (!zoneRecord || zoneRecord.expansion !== expansion.$id) return;
                        if (zoneMedals.gold) medalPoints += 3;
                        else if (zoneMedals.silver) medalPoints += 2;
                        else if (zoneMedals.bronze) medalPoints += 1;
                    });
                    g.expansionMedalPoints[expansion.$id] = medalPoints;
                });
                $scope.guilds.$save(g);
            });
        }
        $scope.approveWithMedals = function(item) {
            var targetGuild = $scope.guilds.$getRecord(item.guild);
            var bossRecord = $scope.bosses.$getRecord(item.boss);
            if (targetGuild && bossRecord) {
                if (!targetGuild.bossProgression) targetGuild.bossProgression = {};
                if (!targetGuild.expansionPoints) targetGuild.expansionPoints = {};
                var existingBossRecord = targetGuild.bossProgression[item.boss];
                var oldPoints = existingBossRecord ? typeof existingBossRecord === 'object' ? Number(existingBossRecord.points) : Number(existingBossRecord) : 0;
                var pointDelta = Number(bossRecord.points) - oldPoints;
                targetGuild.bossProgression[item.boss] = {
                    points: bossRecord.points,
                    timestamp: new Date(item.timestamp).toISOString()
                };
                var currentExpansionPoints = targetGuild.expansionPoints[item.expansion] ? Number(targetGuild.expansionPoints[item.expansion]) : 0;
                targetGuild.expansionPoints[item.expansion] = currentExpansionPoints + pointDelta;
                // Check if this boss completion clears a zone
                var zoneRecord = $scope.zones.$getRecord(item.zone);
                if (zoneRecord) {
                    // Find all bosses in this zone
                    var bossesInZone = [];
                    angular.forEach($scope.bosses, function(b) {
                        if (b.zone === item.zone) bossesInZone.push(b);
                    });
                    // Check if all bosses in this zone are now cleared by this guild
                    var allCleared = true;
                    angular.forEach(bossesInZone, function(b) {
                        if (!targetGuild.bossProgression[b.$id]) allCleared = false;
                    });
                    // If zone is cleared, medal placement is based on the guild's clear timestamp,
                    // not the approval order. This keeps earlier zone clears in the top medal slots.
                    if (allCleared) recalculateZoneMedals(item.zone, item.guild, item.timestamp);
                }
                $scope.guilds.$save(targetGuild);
            }
            // Clean up the submission
            $scope.cleanupSubmission(item);
        };
        $scope.approveLegacy = function(item) {
            var bossRecord = $scope.bosses.$getRecord(item.boss);
            if (!bossRecord) return;
            // 1. Identify all guilds that have already killed this boss to determine chronological order
            var killers = [];
            angular.forEach($scope.guilds, function(g) {
                // We skip the current target guild to handle it specifically as the incoming entry
                if (g.$id !== item.guild && g.bossProgression && g.bossProgression[item.boss]) {
                    var record = g.bossProgression[item.boss];
                    // Handle legacy data where points might be just a number
                    var pts = typeof record === 'object' ? Number(record.points) : Number(record);
                    var ts = typeof record === 'object' && record.timestamp ? record.timestamp : 0;
                    killers.push({
                        guild: g,
                        timestamp: new Date(ts).getTime(),
                        oldPoints: pts
                    });
                }
            });
            // 2. Add the current submission to the list
            var targetGuild = $scope.guilds.$getRecord(item.guild);
            if (targetGuild) {
                var existingRecord = targetGuild.bossProgression ? targetGuild.bossProgression[item.boss] : null;
                var existingPts = 0;
                if (existingRecord) existingPts = typeof existingRecord === 'object' ? Number(existingRecord.points) : Number(existingRecord);
                killers.push({
                    guild: targetGuild,
                    timestamp: new Date(item.timestamp).getTime(),
                    oldPoints: existingPts
                });
            }
            // 3. Sort by timestamp ascending
            killers.sort(function(a, b) {
                return a.timestamp - b.timestamp;
            });
            // 4. Calculate what the initial (1st place) points were/are
            // Each existing kill reduced points by 2. We use the count before this approval for the base calculation.
            var countBeforeApproval = killers.length - 1;
            var initialPoints = Number(bossRecord.points) + countBeforeApproval * 2;
            // 5. Update everyone's points based on the new chronological order
            angular.forEach(killers, function(k, index) {
                var newPoints = Math.max(26, initialPoints - index * 2);
                var diff = newPoints - k.oldPoints;
                if (!k.guild.bossProgression) k.guild.bossProgression = {};
                if (!k.guild.expansionPoints) k.guild.expansionPoints = {};
                // Store both points and the timestamp for future comparisons
                k.guild.bossProgression[item.boss] = {
                    points: newPoints,
                    timestamp: new Date(k.timestamp).toISOString()
                };
                // Adjust the total expansion points by the delta (handles point shifting)
                var currentExpPts = k.guild.expansionPoints[item.expansion] ? Number(k.guild.expansionPoints[item.expansion]) : 0;
                k.guild.expansionPoints[item.expansion] = currentExpPts + diff;
                $scope.guilds.$save(k.guild);
            });
            // 6. Update the Boss record points for the NEXT guild to kill it
            bossRecord.points = Math.max(26, initialPoints - killers.length * 2);
            $scope.bosses.$save(bossRecord);
            // Clean up the submission
            $scope.cleanupSubmission(item);
        };
        $scope.approve = function(item) {
            if (!$scope.isAdmin) {
                alert('Only administrators can approve submissions.');
                return;
            }
            if (confirm('Would you like to approve this submission?')) {
                var expansionRecord = $scope.expansions.$getRecord(item.expansion);
                var expansionName = expansionRecord ? expansionRecord.name : '';
                if (expansionName === 'Echoes of Faydwer') $scope.approveLegacy(item);
                else $scope.approveWithMedals(item);
            }
        };
    }
]);

//# sourceMappingURL=list.f8316d61.js.map
